import * as Yup from "yup";

const UserSignUpValidation = Yup.object().shape({
  firstName: Yup.string()
    .required("First name is required!")
    .test(
      "no-empty-blank-space",
      "First name cannot be an empty blank space(s)",
      (value: any) => {
        return value && value.trim() !== "";
      }
    ),
  lastName: Yup.string()
    .required("Last name is required!")
    .test(
      "no-empty-blank-space",
      "Last name cannot be an empty blank space(s)",
      (value: any) => {
        return value && value.trim() !== "";
      }
    ),
  email: Yup.string()
    .email("Email ID is invalid!")
    .required("Email ID is required!"),
});

export default UserSignUpValidation;
